import { AriaAttributes } from "react";
import { SortDirection } from "src/constants/sort-direction";

export const getAriaSort = (sortDirection: false | SortDirection): AriaAttributes["aria-sort"] => {
    if (sortDirection === SortDirection.Ascending) {
        return "ascending";
    }

    if (sortDirection === SortDirection.Descending) {
        return "descending";
    }

    return "none";
};
